import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineDiluentNameDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineDiluentName/GetDetail?` + params, null);

export const GetMedicineDiluentNameList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineDiluentName/GetList?` + params, null);

export const CreateMedicineDiluentName = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineDiluentName/Create`, data);

export const UpdateMedicineDiluentName = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineDiluentName/Update`, data);

export const DeleteMedicineDiluentName = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineDiluentName/Delete`, data);






